import(/* webpackMode: "eager" */ "/app/apps/web/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AppChromeLoader"] */ "/app/apps/web/components/app-chrome-loader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthHydrator"] */ "/app/apps/web/components/auth-hydrator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImpersonationBanner"] */ "/app/apps/web/components/layout/impersonation-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["I18nProvider"] */ "/app/apps/web/providers/i18n-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QueryProvider"] */ "/app/apps/web/providers/query-provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.3.8_@babel+core@7.29.0_@playwright+test@1.58.2_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-inter\",\"preload\":true}],\"variableName\":\"inter\"}");
